var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-setup" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "setupForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-text": "Submitting...",
          },
        },
        [
          _c("h4", { staticClass: "text-center" }, [_vm._v("IMPORTANT")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "As an office bearer we require additional security before you can access the member portal."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "You will only complete this registration process once, and will be required to use our two-factor authentication process each time you login after this."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We have sent a text message to your mobile number ending in " +
                _vm._s(_vm.phoneEnding) +
                ". Please enter the 6 digit code from that message below:"
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "token-input",
              attrs: { label: "Token", "inline-message": true, prop: "token" },
            },
            [
              _c("el-input", {
                attrs: { size: "medium", maxlength: "6" },
                model: {
                  value: _vm.form.token,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "token", $$v)
                  },
                  expression: "form.token",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v("Your token expires in 2 minutes"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If your mobile number does not end in " +
                _vm._s(_vm.phoneEnding) +
                ", please contact us on (02) 8356 0300"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you forget your password you will be required to provide an answer to a security question. Please select a question and provide your answer."
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "select-question",
              attrs: { "inline-message": true, prop: "question" },
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "Choose a security question?",
                    size: "medium",
                  },
                  model: {
                    value: _vm.form.question,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "question", $$v)
                    },
                    expression: "form.question",
                  },
                },
                _vm._l(_vm.questions, function (question) {
                  return _c("el-option", {
                    key: question.key,
                    attrs: { label: question.value, value: question.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { "inline-message": true, prop: "answer" } },
            [
              _c("el-input", {
                attrs: { size: "medium" },
                model: {
                  value: _vm.form.answer,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "answer", $$v)
                  },
                  expression: "form.answer",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: "Authentication failed",
              type: "error",
              description: _vm.error,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-action" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-confirm",
              attrs: { type: "primary", disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.submitForm("setupForm")
                },
              },
            },
            [_vm._v("Continue")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.cancelLogIn } },
            [_vm._v("Cancel and return to login")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }